import { render, staticRenderFns } from "./TableCellAlarm.vue?vue&type=template&id=130774e4&"
import script from "./TableCellAlarm.vue?vue&type=script&lang=js&"
export * from "./TableCellAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign({QIcon}, component.options.components || {})
